export function init() {
	// Select the login route before SvelteKit downloads the chat route.
	if (
		(location.pathname === '/' || location.pathname.startsWith('/c/')) &&
		!localStorage.getItem('token')
	) {
		const redirect = encodeURIComponent(location.pathname + location.search + location.hash);
		history.replaceState(history.state, '', `/auth?redirect=${redirect}`);
	}
}
